import React, { FC } from 'react'
import FormHelperText from '@mui/material/FormHelperText'
import makeStyles from '@mui/styles/makeStyles';

import ClickLink from './ClickLink'
import {
  IVoidCallback,
} from '@kaidam/fc-shared/src/types/utils'


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    flexGrow: 1,
  },
  link: {
    flexGrow: 0,
  },
}))

interface FormTitleProps {
  title?: string,
  linkTitle?: string,
  onClick?: IVoidCallback,
}

const FormTitle: FC<React.PropsWithChildren<FormTitleProps>> = ({
  title,
  linkTitle,
  onClick,
  children,
}) => {

  const classes = useStyles()
  let displayTitle = children

  if(title) {
    displayTitle = (
      <FormHelperText>{ title }</FormHelperText>
    )
  }

  return (
    <div className={ classes.root }>
      <div className={ classes.title }>
        { displayTitle }
      </div>
      {
        onClick && (
          <div className={ classes.link }>
            &nbsp;&nbsp;
            <ClickLink
              onClick={ onClick }
            >
              { linkTitle }
            </ClickLink>
          </div>
        )
      }
    </div>
  )
}

export default FormTitle